import { defineSectionEvents } from '../utils';

export const POPOUT_EVENTS = defineSectionEvents('Popout', 'Window', {
  POPOUT_WINDOW_OPENED: {
    action: 'Window Opened',
    description:
      'A detached popout browser window was successfully created via PopoutService.',
    properties: {
      windowName: {
        type: 'string',
        description:
          "Stable window identifier passed by the caller (e.g. 'ItemsPopout', 'DashboardChartPopout').",
      },
      popoutType: {
        type: 'string',
        description:
          "Popout variant: data.popoutType ('ai-agent'), or 'dashboard'/'table' fallback.",
      },
    },
  },
});
